import React from "react";
import { Grid, Link } from "@material-ui/core";
import { FormikConsumer } from "formik";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import { Button } from "components/haven-design/buttons";
import { loginStyles } from "./styles";
import styles from "./Login.module.css";
import TimerButton from "./timer-button";

const LoginFormMobile: React.FC<{sendCode: () => void; resetAwaitingCode: () => void;}> =
({ sendCode, resetAwaitingCode }) => (
  <Grid container spacing={2} direction="column" alignItems="center" justifyContent="center">
    <Grid item xs={12}>
      <InputWithErrorLabel
        autoFocus
        label="Login Code"
        title="4 digit numeric code that we texted you"
        name="code"
        id="code"
        type="text"
        style={loginStyles.loginInput}
      ></InputWithErrorLabel>
      <TimerButton sendCode={sendCode} />
    </Grid>
    <Grid item>
      <FormikConsumer>
        {({ isSubmitting }) => (
          <Button
            id="login-btn"
            type="submit"
            color="primary"
            size="L"
            className={styles.loginButton}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Loading..." : "Verify & Log In"}
          </Button>
        )}
      </FormikConsumer>
    </Grid>
    <Grid item>
      <Link component="button" variant="body2" onClick={resetAwaitingCode}>
        Go back
      </Link>
    </Grid>
  </Grid>
);

export default LoginFormMobile;
